"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTrackingPages = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const react_error_boundary_1 = require("react-error-boundary");
const orderBy_1 = __importDefault(require("lodash/orderBy"));
const AccountContext_1 = require("contexts/AccountContext");
const TrackingPageCard_1 = require("components/Dashboard/TrackingPages/TrackingPageCard");
const graphql_1 = require("components/Dashboard/TrackingPages/graphql");
const graphql_2 = require("components/Dashboard/Account/Overview/graphql");
const styles_1 = require("./styles");
const ListTrackingPages = ({ selectedTrackingPage, themes, trackingPages, onChangeSelectedTrackingPage, onChangeSuccessAlert, onChangeSuccessTitle, onOpenDeleteModal, onScrollToTop }) => {
    const handleError = (0, react_error_boundary_1.useErrorHandler)();
    const { account, setAccount } = (0, AccountContext_1.useAccount)();
    const [updateAccount, { error }] = (0, client_1.useMutation)(graphql_2.UPDATE_ACCOUNT, {
        refetchQueries: [
            { query: graphql_1.GET_TRACKING_PAGES, variables: { accountId: account === null || account === void 0 ? void 0 : account.id } },
            'externalTrackingPage'
        ],
        onCompleted: ({ updateAccount: { account: updatedAccount } }) => {
            onChangeSuccessTitle(`'${selectedTrackingPage === null || selectedTrackingPage === void 0 ? void 0 : selectedTrackingPage.title}' set as default tracking page URL`);
            setAccount(updatedAccount);
            onChangeSuccessAlert();
            onChangeSelectedTrackingPage(null);
            onScrollToTop();
        }
    });
    const handleOpenPopover = (0, react_1.useCallback)((trackingPage) => {
        if ((selectedTrackingPage === null || selectedTrackingPage === void 0 ? void 0 : selectedTrackingPage.id) === trackingPage.id) {
            onChangeSelectedTrackingPage(null);
        }
        else {
            onChangeSelectedTrackingPage(trackingPage);
        }
    }, []);
    const handleClosePopover = (0, react_1.useCallback)(() => {
        onChangeSelectedTrackingPage(null);
    }, []);
    const handleOpenDeleteModal = (0, react_1.useCallback)((trackingPage) => {
        onChangeSelectedTrackingPage(trackingPage);
        onOpenDeleteModal();
    }, []);
    const handleSetDefaultAction = (0, react_1.useCallback)((trackingPageUrl) => {
        if (!account) {
            throw new Error('No account selected');
        }
        updateAccount({
            variables: {
                input: {
                    id: account.id,
                    name: account.name,
                    defaultTrackingPageUrl: trackingPageUrl
                }
            }
        });
    }, []);
    if (error) {
        handleError(error);
    }
    const sortedTrackingPages = (0, react_1.useMemo)(() => (0, orderBy_1.default)(trackingPages, ['insertedAt'], ['desc']), [trackingPages]);
    /**
     * TODO NOTE: This logic is currently flawed and there's no new business direction
     * on what to do with it yet. A theme can be the 'main' theme when the tracking
     * page is created, but someone can modify it afterwards within Shopify without
     * our knowledge. When this happens, a theme we set a tracking page to may no
     * longer be considered the 'main' theme going forward, and we'll end up flagging
     * it as unpublished. As a short term workaround, the tracking page card will
     * always show a link as active going forward.
     */
    const trackingPageCards = sortedTrackingPages.map((item) => {
        // assume published unless we have a specific themeId stored that we can
        // check definitively if published
        const unkownPublishState = !item.themeId || themes.length === 0;
        const belongsToPublishedTheme = !!themes.find(({ id, role }) => id === item.themeId && role === 'main');
        const published = unkownPublishState || belongsToPublishedTheme;
        return (react_1.default.createElement(TrackingPageCard_1.TrackingPageCard, { key: item.id, onClosePopover: handleClosePopover, onOpenDeleteModal: handleOpenDeleteModal, onOpenPopover: handleOpenPopover, onSetDefaultAction: handleSetDefaultAction, popoverIsActive: (selectedTrackingPage === null || selectedTrackingPage === void 0 ? void 0 : selectedTrackingPage.id) === item.id, published: published, trackingPage: item }));
    });
    return react_1.default.createElement(styles_1.Container, null, trackingPageCards);
};
exports.ListTrackingPages = ListTrackingPages;
